import { render, staticRenderFns } from "./confirmar-perfil-card.vue?vue&type=template&id=74dc0740&scoped=true&"
import script from "./confirmar-perfil-card.vue?vue&type=script&lang=js&"
export * from "./confirmar-perfil-card.vue?vue&type=script&lang=js&"
import style0 from "./confirmar-perfil-card.vue?vue&type=style&index=0&id=74dc0740&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74dc0740",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('74dc0740')) {
      api.createRecord('74dc0740', component.options)
    } else {
      api.reload('74dc0740', component.options)
    }
    module.hot.accept("./confirmar-perfil-card.vue?vue&type=template&id=74dc0740&scoped=true&", function () {
      api.rerender('74dc0740', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/aawz-intelligence-v2/components/confirmar-perfil-card/confirmar-perfil-card.vue"
export default component.exports